var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPutType = function SvgPutType(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.857 47.8572C94.857 73.8935 73.7504 95.0001 47.7141 95.0001C21.6779 95.0001 0.571289 73.8935 0.571289 47.8572C0.571289 21.8209 21.6779 0.714355 47.7141 0.714355C73.7504 0.714355 94.857 21.8209 94.857 47.8572Z",
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7141 90.2858C71.1468 90.2858 90.1427 71.2899 90.1427 47.8572C90.1427 24.4246 71.1468 5.42864 47.7141 5.42864C24.2815 5.42864 5.28557 24.4246 5.28557 47.8572C5.28557 71.2899 24.2815 90.2858 47.7141 90.2858ZM47.7141 95.0001C73.7504 95.0001 94.857 73.8935 94.857 47.8572C94.857 21.8209 73.7504 0.714355 47.7141 0.714355C21.6779 0.714355 0.571289 21.8209 0.571289 47.8572C0.571289 73.8935 21.6779 95.0001 47.7141 95.0001Z",
    fill: "#EC2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2854 45.7358C69.9423 45.7358 71.2854 47.079 71.2854 48.7358V49.0216C71.2854 50.6784 69.9423 52.0216 68.2854 52.0216L27.1426 52.0216C25.4857 52.0216 24.1426 50.6784 24.1426 49.0216L24.1426 48.7358C24.1426 47.079 25.4857 45.7358 27.1426 45.7358L68.2854 45.7358Z",
    fill: "#EC2F2F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPutType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/put_type.ccfb63f1.svg";
export { ForwardRef as ReactComponent };